export default {
    title: 'Settings',
    back: 'Back',
    myProfile: 'My Profile',
    personalSettings: 'Personal Settings',
    notifications: 'Notifications',
    notificationDefaults: 'Default notifications',
    myOrganization: 'My Organization',
    organizationDetails: 'Organization Details',
    members: 'Members',
    roles: 'Roles & Permissions',
    helpSupport: 'Help & Support',
    helpCenter: 'Help Center',
    developer: 'Developer',
    apiTokens: 'API Access',
    advancedSettings: 'Advanced Settings',
    dangerZone: 'Danger Zone',
    deleteAccount: 'Delete account',
    exports: 'Exports',
    mediaPlayers: 'Media players',
    bandwidth: 'Bandwidth',
    advertising: 'Advertising',
    partners: 'Partners',
    workspaces: 'Workspaces',
    ideoCards: 'Ideo Cards',
}
